// extracted by mini-css-extract-plugin
export default {"description":"page-description_description__L8+k9"};